import { render, staticRenderFns } from "./MainChart.vue?vue&type=template&id=90e72e8a&scoped=true&"
import script from "./MainChart.vue?vue&type=script&lang=js&"
export * from "./MainChart.vue?vue&type=script&lang=js&"
import style0 from "./MainChart.vue?vue&type=style&index=0&id=90e72e8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90e72e8a",
  null
  
)

export default component.exports